module.exports = __webpack_public_path__ + "mintandmustard.webp?b381b68957fd047f30b520afe2db95c0";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/mintandmustard.webp
// module id = 294
// module chunks = 0